import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { environment } from 'src/environments/environment';
import { Order } from '../models/order';
import { first, map } from 'rxjs/operators';
import { convertSnaps } from './db-utils';
import { Observable, of } from 'rxjs';
import { LoaderService } from './loader.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  window: any = window;
  handler = this.window.ePayco.checkout.configure({ key: environment.key, test: environment.testrequest });
  currentOrder: Order;

  constructor(private angularFirestore: AngularFirestore, private loaderService: LoaderService, private userService: UserService) { }


  saveOrder(order: Order): Promise<any>{
    console.log(order);
    return this.angularFirestore.collection('orders').add({...order});
  }

  configEpaycoPayment(order: Order){
    var mediosDeshabilitados = [];

    var data = {
      //Parametros compra (obligatorio)
      invoice: order.id, //Id de la factura, no puede ser repetido
      currency: environment.currencycode,
      name: "Plan de facturacion electronica",
      description: "Plan de facturacion electronica",
      tax_base: '0',
      tax: '0',
      amount: order.total,
      country: "co",
      lang: "es",
      external: environment.externalPasarela,
      //Onpage="false" - Standard="true"
      //Atributos opcionales
      // method: 'GET',
      // extra1: this.dataUser.Id,
      extra1: order.customerId,//Id buyer
      extra2: order.customerEmail, //Email buyer
      extra3: order.totalRevenuePoints,
      response: environment.urlresponse,
      confirmation: environment.urlconfirmation,
      methodsDisable: mediosDeshabilitados
    }

    return data;
  }


  deployEpaycoCheckout(data) {
    this.loaderService.isLoading = of(true);
    this.handler.onCloseModal = this.onCloseEpaycoModal
    this.handler.open(data)
    this.userService.clearShoppingCart();
  }


  onCloseEpaycoModal() {
    // alert('Close ePayco Modal!!!!!!!')
    console.log('se cerro');
    this.loaderService.isLoading = of(false);

  }

  getOrdersByCustomerId(customerId: string): Observable<Order[]> {
    return this.angularFirestore.collection('orders',
      ref => ref.where('customerId', '==', customerId).orderBy('date', 'desc'))
      .snapshotChanges()
      .pipe(
        map(snaps => {
          const orders = convertSnaps<Order>(snaps)
          return orders;
        }), first()
      )
  }

}
